import { ParsedAccountablePlanData } from 'services/bookkeeping/queries/useAccountablePlans/useAccountablePlans.interface';

export const MAX_PHONE_INTERNET_PERCENT = 70; // Maximum business percentage for phone/internet

export function calculateHomeOfficePercentage(squareFootageOffice: number, squareFootageHome: number) {
    if (squareFootageHome === 0) {
        return 0;
    }

    return squareFootageOffice / squareFootageHome;
}

export function calculateHomeOfficeTotal(plan: ParsedAccountablePlanData) {
    const commonFields = [plan.cost_security, plan.cost_cleaning, plan.cost_utilities];

    const ownerFields = [
        plan.cost_HOA,
        plan.cost_home_insurance,
        plan.cost_property_taxes,
        plan.cost_mortgage_interest,
        ...commonFields,
    ];

    const renterFields = [plan.cost_rent, plan.cost_rent_insurance, ...commonFields];

    const expenses = plan.is_renting ? renterFields : ownerFields;

    return expenses.reduce((sum, expense) => sum + expense, 0);
}

export function calculateHomeOfficeReimbursableAmount(plan: ParsedAccountablePlanData) {
    const homeOfficeTotal = calculateHomeOfficeTotal(plan);
    const homeOfficePercentage = calculateHomeOfficePercentage(plan.square_footage_office, plan.square_footage_home);

    return homeOfficeTotal * homeOfficePercentage;
}

export function calculatePhoneAndInternetReimbursableAmount(plan: ParsedAccountablePlanData) {
    const phoneCost = plan.cost_phone;
    const internetCost = plan.cost_internet;
    const businessPercentage = plan.internet_phone_business_percent;

    const totalCost = phoneCost + internetCost;
    return totalCost * (businessPercentage / 100);
}

export function calculatePhoneReimbursableAmount(plan: ParsedAccountablePlanData) {
    const phoneCost = plan.cost_phone;
    const businessPercentage = plan.internet_phone_business_percent;

    return phoneCost * (businessPercentage / 100);
}

export function calculateInternetReimbursableAmount(plan: ParsedAccountablePlanData) {
    const internetCost = plan.cost_internet;
    const businessPercentage = plan.internet_phone_business_percent;

    return internetCost * (businessPercentage / 100);
}

export function calculateMileageReimbursableAmount(plan: ParsedAccountablePlanData, mileageRate = 0) {
    const businessMiles = plan.miles_driven_business;
    return businessMiles * mileageRate;
}

export function calculateMixedUseSubtotal(plan: ParsedAccountablePlanData, mileageRate = 0) {
    const homeOfficeAmount = calculateHomeOfficeReimbursableAmount(plan);
    const phoneInternetAmount = calculatePhoneAndInternetReimbursableAmount(plan);
    const mileageAmount = calculateMileageReimbursableAmount(plan, mileageRate);

    return homeOfficeAmount + phoneInternetAmount + mileageAmount;
}

export function calculateTotalReimbursableAmount(
    plan: ParsedAccountablePlanData,
    outOfPocketExpenses: number[] = [],
    mileageRate = 0
) {
    const mixedUseSubtotal = calculateMixedUseSubtotal(plan, mileageRate);
    const outOfPocketTotal = outOfPocketExpenses.reduce((sum, expense) => sum + expense, 0);

    return mixedUseSubtotal + outOfPocketTotal;
}
